const FooterCopyright = () => {
  return (
    <div className="border-t border-gray-200 pt-6 sm:pt-8 text-center">
      <p className="text-gray-500 text-xs sm:text-sm mb-3 sm:mb-4">
        &copy; 2026 Orbitra Technologies. All rights reserved.
      </p>
      <p className="text-gray-400 text-[11px] sm:text-xs max-w-3xl mx-auto leading-relaxed">
        Privacy & Trust: Detailed location data is used strictly for operational safety purposes
        during active trips only. It never runs silently in the background and is fully governed by
        user consent.
      </p>
    </div>
  );
};

export default FooterCopyright;
